import { IntegrationConfig } from '../types';

export type HubspotIntegrationId = { integrationId: string | 'new' };

export type HubspotIntegrationProvider = {
  authType: string;
  oauthUrl: string;
  oauthReauthUrl: string;
};

export type HubspotConfig = IntegrationConfig<{
  externalAccountId: string;
}>;

export enum HubspotSyncTypes {
  SyncTwoWay = 'SYNC_TWO_WAY',
  SyncNativeToExternal = 'SYNC_NATIVE_TO_EXTERNAL',
  SyncExternalToNative = 'SYNC_EXTERNAL_TO_NATIVE',
  None = 'NONE',
}

export type HubspotFieldMapping = {
  fieldMappingConfigId?: number;
  integrationId: number;
  externalIntegrationType: 'hubspot';
  resourceMappingConfigId: number;
  nativeFieldId: number;
  nativeFieldName?: string;
  nativeFieldLabel: string;
  externalFieldId: string;
  externalFieldName: string;
  syncType: HubspotSyncTypes;
  enabled?: boolean;
  allowedSyncTypes: [HubspotSyncTypes];
};

export type HubspotResourceMapping = {
  resourceMappingConfigId: number;
  integrationId: number;
  externalIntegrationType: 'hubspot';
  nativeResourceType: string;
  externalResourceType: string;
  syncType: HubspotSyncTypes;
  fieldMappings: HubspotFieldMapping[];
  enabled?: boolean;
};

export type HubspotResourceCreatePayload = Pick<
  HubspotResourceMapping,
  | 'externalIntegrationType'
  | 'externalResourceType'
  | 'nativeResourceType'
  | 'syncType'
  | 'enabled'
>;

export type HubspotObject = {
  id: string;
  name: string;
  url?: string;
  type?: string;
};
